import { useEffect, useRef } from 'react';

import type { ChatMessage } from '../lib/types';

const BUBBLE_BASE: React.CSSProperties = {
  maxWidth: '70%',
  padding: '8px 12px',
  borderRadius: '12px',
  fontSize: '14px',
  lineHeight: '1.4',
  wordBreak: 'break-word',
};

export function MessageList({ messages }: { messages: readonly ChatMessage[] }): JSX.Element {
  const endRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  return (
    <div
      style={{
        flex: 1,
        overflowY: 'auto',
        padding: '12px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
      }}
    >
      {messages.length === 0 && (
        <div
          style={{
            margin: 'auto',
            color: 'var(--lume-muted)',
            fontSize: '13px',
            textAlign: 'center',
          }}
        >
          Envie uma mensagem para começar a conversa.
        </div>
      )}
      {messages.map((msg) => {
        const isClient = msg.origin === 'customer';
        return (
          <div
            key={msg.id}
            style={{
              display: 'flex',
              justifyContent: isClient ? 'flex-end' : 'flex-start',
            }}
          >
            <div
              style={{
                ...BUBBLE_BASE,
                background: isClient ? 'var(--lume-client)' : 'var(--lume-ai)',
                color: isClient ? 'var(--lume-client-text)' : 'var(--lume-text)',
              }}
              data-origin={msg.origin}
              data-testid={`message-${msg.origin}`}
            >
              {msg.content}
            </div>
          </div>
        );
      })}
      <div ref={endRef} />
    </div>
  );
}
